module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-10-39300c66886a21ca4450c5b691e64cd5.jpg";